import CommentaryWidget from "./CommentaryWidget";

const Widget = (props) => {
  const { widget, match } = props;

  const widgetOpta = () => {
    switch (widget) {
        case "comentary":
            return (
                <CommentaryWidget match={match}/>
            );
        }
    };

  return (
      <>
        {widgetOpta()}
      </>
  );
};

export default Widget;
